import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { COMPANY } from "@/data/site";
import Reveal from "@/components/Reveal";

const CTASection = () => (
  <section className="border-t border-white/10 bg-surface">
    <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32">
      <Reveal>
        <p className="mb-6 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand" />
          Un progetto in mente?
        </p>
        <h2 className="font-display font-extrabold uppercase leading-[0.92] tracking-tight text-white text-[clamp(2.75rem,11vw,10rem)]">
          Lavoriamo
          <br />
          insieme<span className="text-brand">.</span>
        </h2>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
          Sopralluogo, progettazione e preventivo. Raccontaci le tue esigenze e ti risponderemo con
          una soluzione su misura.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link
            to="/contatti"
            data-testid="cta-preventivo"
            className="group inline-flex items-center gap-3 rounded-md bg-brand px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-white transition-all duration-300 hover:bg-brand-hover"
          >
            Richiedi un preventivo
            <ArrowRight className="h-[18px] w-[18px] transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <a
            href={COMPANY.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp"
            className="inline-flex items-center gap-3 rounded-md border border-white/15 px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors hover:border-white/40"
          >
            Scrivici su WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
